export const trimString = (string: string) => string.split(' ').join('')
